module.exports = __webpack_public_path__ + "img/onboarding.3d2e0995.png";